import { render, staticRenderFns } from "./ApruveEmailView.vue?vue&type=template&id=332a31cd&scoped=true"
import script from "./ApruveEmailView.vue?vue&type=script&lang=js"
export * from "./ApruveEmailView.vue?vue&type=script&lang=js"
import style0 from "./ApruveEmailView.vue?vue&type=style&index=0&id=332a31cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332a31cd",
  null
  
)

export default component.exports